import {Routes, Route} from 'react-router-dom'
import Login from '../Component/Login/Login'
import LoginAdmin from '../Component/Login/LoginAdmin'
import DisplayDocument from '../Component/PDFWebsite/PDFWebsit'
export default function RouterDefault() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path = '/LoginAdmin' element={<LoginAdmin/>} />
    </Routes>
    )
}
